import {
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
} from "@angular/core";
import { ButtonCtaComponent } from "@components/button-cta/button-cta.component";
import { Catalog, ProductCollectionDisplayTypeEnum } from "@cureskin/api-client/src/server-api";
import { CsIconModule } from "@components/icon";

@Component({
  selector: "app-product-horizontal",
  imports: [ButtonCtaComponent, CsIconModule],
  templateUrl: "./product-horizontal.component.html",
  styles: [
    `
      :host {
        display: flex;
        position: relative;
        border-radius: 10px;
        background-color: white;
        justify-content: space-between;
        overflow: hidden;
        height: 100%;
        font-size: 16px !important;
      }
    `,
  ],
  standalone: true
})
export class ProductHorizontalComponent {
  isLocked: Signal<boolean> = input(false);
  product: InputSignal<Catalog> = input();
  productInCart: InputSignal<any> = input();
  gotoProduct: OutputEmitterRef<Catalog> = output();
  addToCart: OutputEmitterRef<{ product: Catalog; image: HTMLImageElement }> =
    output();
  reomveFromCart: OutputEmitterRef<Catalog> = output();
  type: InputSignal<ProductCollectionDisplayTypeEnum> = input<ProductCollectionDisplayTypeEnum>(ProductCollectionDisplayTypeEnum.BANNER);
  readonly DisplayType = ProductCollectionDisplayTypeEnum;

  productImage: Signal<string> = computed(
    () =>
      (this.product() as any)?.productImage ||
      this.product()?.rebrandedImageWithBackground?.[0] ||
      this.product()?.productUnboxedImage?.[0] ||
      this.product()?.images?.[0]
  );
  productTitle: Signal<string> = computed(() => this.product()?.title);

  purpose: Signal<string> = computed(() => this.product()?.purpose);
  productQuantity: Signal<number> = computed(() => {
    if (!this.productInCart()) return 0;

    // If productInCart is an object with quantity property
    if (
      typeof this.productInCart() === "object" &&
      this.productInCart()?.quantity !== undefined
    ) {
      return this.productInCart().quantity;
    }

    // If productInCart is just a number
    if (typeof this.productInCart() === "number") {
      return this.productInCart();
    }

    return 0;
  });

  addToCartAction(product: Catalog, image: HTMLImageElement): void {
    this.addToCart.emit({ product, image });
  }

  removeFromCartAction(product: Catalog): void {
    this.reomveFromCart.emit(product);
  }

  onGotoProduct(product: Catalog): void {
    this.gotoProduct.emit(product);
  }
}
